import { convertHtmlToText } from "@/utils/helpers.js";

export const sfdcTabItems = [
  {
    title: "Search by invoice ids",
    id: "search-invoice",
    active: true,
  },
  { title: "Upload excel", id: "upload-excel" },
  { title: "Archived invoices", id: "archived-invoices" },
];

export const sfdcTableColumns = [
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 180,
    isFrozen: true,
    showInfoIcon: true,
    infoText: "Dispute Invoice number",
    customTooltip: false,
  },
  {
    title: "ODN",
    slotKey: "odn",
    width: 180,
    isFrozen: false,
    showInfoIcon: true,
    infoText: "Official Document number",
    customTooltip: false,
  },
  {
    title: "Dispute reason",
    slotKey: "reasonDescription",
    width: 240,
    showInfoIcon: true,
    infoText: "Dispute reason",
    customTooltip: false,
  },
  {
    title: "SFDC Case Id",
    slotKey: "sfdcCaseId",
    width: 200,
    editableField: true,
    showInfoIcon: true,
    infoText: "Enter SFDC Case Id (Eg: 5009V00000jnEJGQA2)",
    placeholderText: "Enter SFDC Case Id (Eg: 5009V00000jnEJGQA2)",
    validateColumns: ["sfdcCaseId"],
    customTooltip: false,
  },
  {
    title: "Comments",
    slotKey: "noteDescription",
    width: 400,
    editableField: true,
    showInfoIcon: true,
    infoText: "Comments are required(max characters 4000)",
    placeholderText: "Comments are required(max characters 4000)",
    validateColumns: ["noteDescription"],
    customTooltip: false,
  },
  {
    title: "Customer number",
    slotKey: "customerNumber",
    width: 180,
    editableField: false,
    showInfoIcon: true,
    infoText: "Customer number must be 4-30 fields",
    placeholderText: "Customer number is required",
    customTooltip: false,
  },
  {
    title: "Customer email id",
    slotKey: "contactEmail",
    editableField: true,
    width: 200,
    showInfoIcon: true,
    infoText: "Customer email id is required",
    placeholderText: "Customer email id is required",
    validateColumns: ["contactEmail"],
    customTooltip: false,
  },
  {
    title: "Contact Person",
    slotKey: "contactPerson",
    editableField: true,
    width: 240,
    showInfoIcon: true,
    infoText: "Contact person is required",
    placeholderText: "Contact person is required",
    validateColumns: ["contactPerson"],
    customTooltip: false,
  },
  {
    title: "Dispute status",
    slotKey: "statusCodeDesc",
    width: 240,
    showInfoIcon: true,
    customTooltip: false,
  },
  {
    title: "Form Validation",
    slotKey: "formValidation",
    width: 230,
    showInfoIcon: true,
    validateColumns: [
      "reasonDescription",
      "sfdcCaseId",
      "noteDescription",
      "contactEmail",
      "contactPerson",
    ],
    customTooltip: false,
  },
  {
    title: "Action",
    slotKey: "action",
    width: 210,
    showInfoIcon: true,
    validateColumns: [
      "reasonDescription",
      "sfdcCaseId",
      "noteDescription",
      "contactEmail",
    ],
    customTooltip: false,
  },
];

export const sfdcTooltip = (content = "-", errorSlotKeys = []) => {
  let message = [];
  if (errorSlotKeys?.includes("noteDescription"))
    message.push(
      `<li class="sfdc-tootip__content"><span class="error">Comment field</span> must be between 1 - 4000 characters</li>`
    );

  if (errorSlotKeys?.includes("reasonDescription"))
    message.push(
      `<li class="sfdc-tootip__content">Select valid<span class="error"> Dispute Reason</span></li>`
    );

  if (errorSlotKeys?.includes("sfdcCaseId"))
    message.push(
      `<li class="sfdc-tootip__content"><span class="error">SFDC Case Id</span> is invalid</li>`
    );

  if (errorSlotKeys?.includes("contactEmail"))
    message.push(
      `<li class="sfdc-tootip__content"><span class="error">Customer email</span> is invalid</li>`
    );
  if (errorSlotKeys?.includes("contactPerson"))
    message.push(
      `<li class="sfdc-tootip__content"><span class="error">Contact person field</span> must be between 1 - 40 characters</li>`
    );
  message = message.join("");
  return errorSlotKeys?.length
    ? `<div class="sfdc-tootip">
	  <ul>
		${message}
	  </ul>
	</div>`
    : `<div class="sfdc-tootip">
	  <span class="sfdc-tootip__content">${content}</span>
	  </div>`;
};
export const excelKeyMapping = {
  "Invoice Number": "invoiceNumber",
  "Dispute Reason": "reasonDescription",
  "SFDC Case Id": "sfdcCaseId",
  Comments: "noteDescription",
  "Contact Person": "contactPerson",
  "Customer Email": "contactEmail",
};

export const excelKeyMappingForArchived = {
  "Invoice Number": "invoiceNumber",
  "Dispute Reason": "reasonDescription",
  "SFDC Case Id": "sfdcCaseId",
  "Amount Local": "amountLc",
  "Invoice Amount": "invoiceAmount",
  "Billing Document Date(DD-MM-YYYY)": "billingDocumentDate",
  "Invoice Due Date(DD-MM-YYYY)": "invoiceDueDate",
  "Customer Code": "customer",
  "Customer Name": "customerName",
  "Document Date(DD-MM-YYYY)": "documentDate",
  "Document Type": "documentType",
  Currency: "currency",
  "Company Code": "companyCode",
  "Business Area Code": "businessAreaCode",
  "Reference Key": "referenceKey",
  "Contact Email": "contactEmail",
  Comments: "noteDescription",
  "TP Doc Number": "tpDocumentNumber",
  "Local Currency": "localCurrency",
  "Original Disputed Amount": "originalDisputedAmount",
  "Disputed Amount": "disputedAmount",
};
export const sfdcKeys = [
  "invoiceNumber",
  "customerNumber",
  "ohpDisputeId",
  "contactEmail",
  "contactPerson",
  "contactTelNumber",
  "statusCode",
  "disputeStage",
  "reasonDescription",
  "reasonCode",
  "sfdcCaseId",
  "noteDescription",
];

export const closedDisputeStatusCodes = [
  "60",
  "61",
  "62",
  "63",
  "66",
  "67",
  "68",
  "70",
  "71",
  "72",
  "73",
  "74",
  "78",
  "79",
  "69",
];

export const sfdcValidationTypes = {
  reasonDescription: {
    validationType: "select",
    errorMessage: "Select dispute reason",
  },
  sfdcCaseId: {
    validationType: "input",
    errorMessage: "Enter a valid SFDC Case Id",
    maxValue: "18",
    minValue: 18,
    customValidation: (value) => {
      if (!value || value.length === 0) return false;
      // Check if exactly 18 characters
      if (value.length !== 18) return false;
      // Check if starts with 5
      if (value.toString().charAt(0) !== "5") return false;
      // Check if alphanumeric (no spaces or special characters)
      if (!/^[a-zA-Z0-9]+$/.test(value)) return false;
      // Check if contains at least one letter
      return /[a-zA-Z]/.test(value);
    },
  },
  noteDescription: {
    validationType: "textArea",
    errorMessage: "Comments field must be 1 - 4000 characters",
    maxValue: "4000",
    minValue: 0,
  },
  contactEmail: {
    validationType: "email",
    errorMessage: "Customer email is invalid",
  },
  contactPerson: {
    validationType: "input",
    errorMessage: "Contact person field must be 1 - 40 characters",
    maxValue: "40",
    minValue: 0,
  },
};

export const archivedInvoicesTableColumns = [
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 160,
    isFrozen: true,
  },
  {
    title: "Dispute Reason",
    slotKey: "reasonDescription",
    width: 160,
  },
  {
    title: "SFDC Case Id",
    slotKey: "sfdcCaseId",
    width: 160,
  },
  {
    title: "Amount Local",
    slotKey: "amountLc",
    width: 160,
  },
  {
    title: "Invoice amount",
    slotKey: "invoiceAmount",
    width: 180,
  },
  {
    title: "Billing document date",
    slotKey: "billingDocumentDate",
    width: 120,
  },
  {
    title: "Invoice due date",
    slotKey: "invoiceDueDate",
    width: 180,
  },
  {
    title: "Customer code",
    slotKey: "customer",
    width: 160,
  },
  {
    title: "Customer name",
    slotKey: "customerName",
    width: 200,
  },
  {
    title: "Document date",
    slotKey: "documentDate",
    width: 120,
  },
  {
    title: "Document type",
    slotKey: "documentType",
    width: 160,
  },
  {
    title: "Currency",
    slotKey: "currency",
    width: 160,
  },
  {
    title: "Comapany code",
    slotKey: "companyCode",
    width: 160,
  },
  {
    title: "Buisness area code",
    slotKey: "businessAreaCode",
    width: 160,
  },
  {
    title: "Reference key",
    slotKey: "referenceKey",
    width: 160,
  },
  {
    title: "Conatact email",
    slotKey: "contactEmail",
    width: 160,
  },
  {
    title: "Comments",
    slotKey: "noteDescription",
    width: 160,
  },
  {
    title: "TP Doc Number",
    slotKey: "tpDocumentNumber",
    width: 160,
  },
  {
    title: "Local Currency",
    slotKey: "localCurrency",
    width: 160,
  },
  {
    title: "Original Disputed Amount",
    slotKey: "originalDisputedAmount",
    width: 160,
  },
  {
    title: "Disputed Amount",
    slotKey: "disputedAmount",
    width: 160,
  },
  {
    title: "Delete",
    slotKey: "delete",
    isFrozen: true,
    frozenPosition: "right",
    width: 90,
  },
  {
    title: "Validation",
    slotKey: "validation",
    isFrozen: true,
    frozenPosition: "right",
    width: 200,
  },
];
export const lookUpParameters = `CURRENCY`;
